<script setup>
import {useCallsStore} from "@/stores/callsStore";
import {useMediaStore} from "@/stores/mediaStore";
const callsStore = useCallsStore();

// Row styling
function colorRowItem({ item }) {
  if (callsStore.selectedCall[0] === item) {
    return { class: 'selected' };
  }

  if (item.status === 'Ringing') {
    if (item.type === 'Emergency') {
      return { class: 'row row-emergency blink-red' };
    }
    return { class: 'row blink-green' };
  }

  if (item.type === 'Emergency') {
    return { class: 'row row-emergency' };
  }

  return { class: 'row' };
}


// Handle row selection
function handleRowSelection(_, {internalItem}) {
  // toggle selection
  if (callsStore.selectedCall[0] === internalItem.value) {
    callsStore.setSelectedCall();
  } else {
    callsStore.setSelectedCall(internalItem.value);
    useMediaStore().selectedTab = "RADIO";
  }
}

const headersCall = [
  // { title: 'Operator ID', key: 'caller', headerProps: { style: 'font-weight: bold' }, sortable: false },
  {title: 'Train Num / HH Name', key: 'trainNum', headerProps: {style: 'font-weight: bold'}, sortable: false},
  {title: 'Zone', key: 'zoneId', headerProps: {style: 'font-weight: bold'}, sortable: false},
  {title: 'Run & Drv Nr.', key: 'runAndDriveNum', headerProps: {style: 'font-weight: bold'}, sortable: false},
  //{ title: 'Direction', key: 'direction', headerProps: { style: 'font-weight: bold' }, sortable: false },
  {title: 'Status', key: 'status', headerProps: {style: 'font-weight: bold'}, sortable: false},
  {
    title: 'Time',
    key: 'time',
    sortable: false,
    headerProps: {style: 'font-weight: bold'},
    value: item => new Date(item.time).toLocaleDateString() + " - " + new Date(item.time).toLocaleTimeString()
  },
  {title: 'Type', key: 'type', sortable: false, headerProps: {style: 'font-weight: bold'}},
];

</script>

<template>
  <v-app-bar color="surface-light" flat height="220" name="app-bar">
    <v-row class="pa-2 d-flex flex-column width-100" cols="24" md="6">
      <div class="font-weight-bold mb-1 align-self-center" style="font-size: 1rem">
        Incoming Calls
      </div>
      <v-sheet
          class="rounded border flex-grow-1"
          elevation="0"
          max-height="175"
      >
        <v-data-table
            v-model="callsStore.selectedCall"
            :headers="headersCall"
            :items="callsStore.incomingCalls"
            :items-per-page="-1"
            :row-props="colorRowItem"
            clickable-rows
            density="compact"
            fixed-header
            height="173"
            hide-default-footer
            item-value="item.item"
            return-object
            select-strategy="single"
            @click:row="handleRowSelection"
        >
        </v-data-table>
      </v-sheet>
    </v-row>
  </v-app-bar>
</template>

<style scoped>
:deep(.row-emergency) {
  background-color: #EE5A5AFF;
  color: white;
}

:deep(.row:hover) {
  background-color: #E0E0E0;
}

:deep(.row-emergency:hover) {
  background-color: #933030;
  color: white;
}

:deep(.selected) {
  background-color: rgba(36, 59, 159, 0.89);
  color: white;
}

@keyframes blinkGreen {
  0%   { background-color: #2ecc71; }
  50%  { background-color: #ffffff; }
  100% { background-color: #2ecc71; }
}

@keyframes blinkRed {
  0%   { background-color: #e74c3c; }
  50%  { background-color: #ffffff; }
  100% { background-color: #e74c3c; }
}

:deep(.blink-green) {
  animation: blinkGreen 1s infinite;
}

:deep(.blink-red) {
  animation: blinkRed 1s infinite;
}

:deep(.row-emergency.selected) {
  background-color: #8e0404; /* dark red */
  color: white;
}


</style>
